// extracted by mini-css-extract-plugin
export default {"container":"FlexContainer_container__GltJl","column":"FlexContainer_column__3qiHi","stretch":"FlexContainer_stretch__nHV82"};